function waitForElement(getElement, timeout = 10000) {
  return new Promise((resolve) => {
    const startTime = performance.now()

    function check() {
      const element = getElement()

      if (element) {
        resolve(element)
        return
      }

      if (performance.now() - startTime >= timeout) {
        resolve(null)
        return
      }

      requestAnimationFrame(check)
    }

    check()
  })
}

document.addEventListener('DOMContentLoaded', async () => {
  const [klarna, clearpay, paypal] = await Promise.all([
    waitForElement(() =>
      document
        .querySelector('klarna-placement')
        ?.shadowRoot?.querySelector('[part="osm-cta"]')
    ),

    waitForElement(() =>
      document
        .querySelector('square-placement')
        ?.shadowRoot?.querySelector('#logo-link')
    ),

    waitForElement(() =>
      document.querySelector('.paypal-messaging .paypal-messaging__info')
    ),
  ])

  if (klarna) {
    document.querySelector('[data-provider="klarna"]').style.opacity = '1'
  }

  if (clearpay) {
    document.querySelector('[data-provider="clearpay"]').style.opacity = '1'
  }

  if (paypal) {
    document.querySelector('[data-provider="paypal"]').style.opacity = '1'
  }

  document
    .querySelector('[data-provider="klarna"]')
    .addEventListener('click', () => {
      klarna.click()
    })
  document
    .querySelector('[data-provider="clearpay"]')
    .addEventListener('click', () => {
      clearpay.click()
    })
  document
    .querySelector('[data-provider="paypal"]')
    .addEventListener('click', () => {
      paypal.click()
    })
})
